module.exports = __webpack_public_path__ + "media/images/fact_sheet_small-4a1f38f1b9ad2c0e3d2230d65dbed008.png";